import React from 'react';
import styled from 'styled-components';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import { Colors } from 'enums/Colors';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Quote from 'pages/ebooks/components/Quote';
import CardQRcodeVideosPlanoAnual from '../../components/CardQRcodeVideosPlanoAnual';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

interface DataType {
    key: string;
    name: string;
    solucoes: string;
    // estudantes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais.
        `,
        // estudantes: '37.000',
    },
    {
        key: '2',
        name: 'Circuito 360',
        solucoes: `
        O Programa tem como objetivo apoiar as secretarias de educação na
        formulação e gestão de políticas educacionais para os <strong>Anos Iniciais do
        Ensino Fundamental</strong>, com foco na perspectiva de educação integral.
        `,
        // estudantes: '29.000',
    },
    {
        key: '3',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '494',
    },
    {
        key: '4',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '112',
    },
    {
        key: '5',
        name: 'Fórmula da Vitória',
        solucoes: `
        O programa tem como objetivo qualificar a aprendizagem em Língua Portuguesa
        de estudantes dos <strong>Anos Finais do Ensino Fundamental</strong>, contribuindo para
        reverter quadros de reprovação e exclusão no ambiente escolar.
        `,
        // estudantes: '105',
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL ',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

const Styled = {
    CardWhite: styled.div`
        background-color: white;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    CardWhite2: styled.div`
        background-color: #f7f4f3;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,

    CardYellow: styled.div`
        background-color: #f1bc40;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.White};
    `,
};

const PageThreeThreePlanoAnual: React.FC = () => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={31} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3.3 MACEIÓ
                </StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr ',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Localizado no litoral de Alagoas, <strong>Maceió</strong> é a capital do estado, sendo o município mais populoso, com{' '}
                            <strong>mais de um milhão de habitantes.</strong> Sua economia é impulsionada, principalmente, pelo turismo, comércio
                            e serviços. Apesar de ser um importante pólo regional, a cidade enfrenta complexos desafios sociais.
                        </p>
                        <p>
                            A riqueza gerada pela economia da capital, muitas vezes, não é distribuída de forma equitativa. Assim, a cidade lida
                            com altos índices de desigualdade social, que se refletem em questões como a vulnerabilidade social e os indicadores
                            educacionais. É nesse contexto que o Instituto Ayrton Senna estabeleceu uma parceria com o município, com o objetivo
                            de acelerar a qualidade da educação local e mitigar os desafios encontrados no território.
                        </p>
                        <Image
                            width={'60%'}
                            src={fetchStorageFile('anexo_storage_files_17937790982341352862.webp_2025-11-20-1763646810946.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>3.3.1 A EDUCAÇÃO NO MUNICÍPIO</StyledGlobal.Title>
                        <p>
                            O cenário educacional em Maceió é preocupante. Além de resultados em termos de aprendizado bem baixos e inferiores às
                            médias estadual e nacional, o município também apresenta dificuldades expressivas em relação à trajetória dos alunos,
                            com altas taxas de distorção idade-série, reprovação e abandono.
                        </p>
                        <StyledGlobal.TitleYellow>ACESSO</StyledGlobal.TitleYellow>
                        <Styled.CardWhite style={{ padding: '20px' }}>
                            <Image
                                width={'60%'}
                                src={fetchStorageFile('anexo_storage_files_17720269928295006407.png_2025-11-20-1763647206319.png')}
                                alt={`
                                Quadro comparativo dos anos iniciais e finais do Ensino Fundamental, com ícones de escola, professor e matrícula. Nos anos iniciais: 
                                86 escolas, 1.235 professores e 29.958 matrículas. Nos anos finais: 21 escolas, 385 professores e 7.912 matrículas. 
                                `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p style={{ fontSize: '14px' }}>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal.</p>
                        </Styled.CardWhite>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={32} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr ',
                        notebook: '1fr 1fr ',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr ',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                                <p>
                                    Acompanhando o movimento observado no estado de Alagoas e no país, mas em ritmo menor,{' '}
                                    <strong>o percentual de estudantes alfabetizados(as) aumentou de 2023 para 2024 e alcançou 41%.</strong>{' '}
                                    Mesmo com esse aumento, a diferença para a média nacional ainda é expressiva: mais de 18 pontos percentuais.{' '}
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                                <p>
                                    <strong>
                                        A queda na distorção idade-série em Maceió nos últimos 10 anos foi bem mais contida do que aquela
                                        observada na média do estado de Alagoas,
                                    </strong>{' '}
                                    fazendo com que, em 2024, os percentuais de estudantes atrasados(as) no município fossem significativamente
                                    maiores do que a média do estado e do país, tanto nos anos iniciais quanto nos anos finais do Ensino
                                    Fundamental.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Styled.CardWhite2 style={{ padding: '20px' }}>
                            <Image
                                width={'70%'}
                                src={fetchStorageFile('anexo_storage_files_4307646761627971917.png_2025-11-20-1763647579224.png')}
                                alt={`
                                    Gráfico de barras comparando a taxa de alfabetização em 2023 e 2024 para Macaé, Alagoas e Brasil. 
                                    Macaé: 39,2% em 2023 e 41% em 2024. 
                                    Alagoas: 43,9% em 2023 e 48,6% em 2024. 
                                    Brasil: 55,9% em 2023 e 59,2% em 2024. 
                                    Barras em azul escuro representam 2023 e em azul claro representam 2024, com setas indicando aumento nos três casos.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px' }}>
                            <Image
                                width={'70%'}
                                src={fetchStorageFile('anexo_storage_files_17039426724155858720.png_2025-11-20-1763647804123.png')}
                                alt={`
                                    Gráfico de barras comparando a distorção idade-série em 2014 e 2024 para anos iniciais e anos finais, nos recortes Maceió, Alagoas e Brasil. 
                                    Anos iniciais: 
                                    — Maceió: 31% em 2014 e 19% em 2024. 
                                    — Alagoas: 25% em 2014 e 8% em 2024. 
                                    — Brasil: 17% em 2014 e 8% em 2024. 
                                    Anos finais: 
                                    — Maceió: 44% em 2014 e 36% em 2024. 
                                    — Alagoas: 47% em 2014 e 19% em 2024. 
                                    — Brasil: 36% em 2014 e 21% em 2024. 
                                    As barras de 2014 aparecem em azul escuro; as de 2024, em azul claro, com setas indicando reduções. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fontes: MEC - Indicador Criança Alfabetizada. MEC/Inep - Censo Escolar.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={33} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr ',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr ',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>APROVAÇÃO, REPROVAÇÃO E ABANDONO</StyledGlobal.TitleYellow>
                                <p>
                                    <strong>As quedas nas taxas de reprovação e abandono em Maceió foram expressivas</strong> nos últimos 10
                                    anos, reduzindo ao menos pela metade os percentuais observados em 2014. Ainda assim, os percentuais de
                                    aprovação nos anos iniciais e finais do Ensino Fundamental são inferiores àqueles obtidos na média do estado
                                    e na média do país. Além da taxa de reprovação, <strong>o abandono ainda é preocupante no município.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Styled.CardWhite2>
                                    <Image
                                        width={'100%'}
                                        src={fetchStorageFile('anexo_storage_files_4850802936925903543.png_2025-11-20-1763648902621.png')}
                                        alt={`
                                            Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando Maceió, Alagoas e Brasil. Nos anos iniciais, aprovação: Maceió 93,7%, Alagoas 97,9%, Brasil 96,9%. 
                                            Reprovação: Maceió 5,5%, Alagoas 1,8%, Brasil 2,8%. 
                                            Abandono: Maceió 0,8%, Alagoas 0,3%, Brasil 0,3%. 
                                            Nos anos finais, aprovação: Maceió 83,4%, Alagoas 93%, Brasil 92%.  
                                            Reprovação: Maceió 11,4%, Alagoas 5,6%, Brasil 6,6%. 
                                            Abandono: Maceió 4,3%, Alagoas 1,4%, Brasil 1,4%. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </Styled.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr ',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                                <p>
                                    Em 2023,{' '}
                                    <strong>
                                        os percentuais de estudantes com aprendizado adequado em Língua Portuguesa em Maceió foram inferiores
                                        àqueles observados na média do estado e do país.
                                    </strong>{' '}
                                    No 5º ano e no 9º ano do Ensino Fundamental a diferença entre o município e a média nacional foi de
                                    aproximadamente 5 pontos percentuais.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Image
                                    width={'100%'}
                                    style={{ objectFit: 'cover', maxHeight: '400px' }}
                                    src={fetchStorageFile('anexo_storage_files_6355222823172597977.webp_2025-11-20-1763649236669.webp')}
                                    alt=""
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Styled.CardWhite2 style={{ width: '100%' }}>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_9882509189563840197.png_2025-11-20-1763649058271.png')}
                                alt={`
                                    Conjunto de ícones de crianças representando a proporção de aprendizado adequado em Língua Portuguesa no 5º ano e 9º ano do Ensino Fundamental. 
                                    5º ano: Maceió 49%, Alagoas 50%, Brasil 54,2%. 
                                    9º ano: Maceió 29,3%, Alagoas 33%, Brasil 33,8%. 
                                    Uma parte dos ícones são pintados de azul de acordo com o percentual de cada território, para indicar os estudantes com nível adequado; o restante dos ícones está em cinza. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fontes: MEC/Inep - Censo Escolar. MEC/Inep - SAEB. Rede Municipal.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={34} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>
                            3.3.2 APRESENTAÇÃO DO <br /> PLANO ANUAL EM MACEIÓ
                        </StyledGlobal.Title>
                        <p>
                            A parceria do Instituto Ayrton Senna com o município de Maceió em 2025 foi concretizada pelo Plano Anual Instituto
                            Ayrton Senna, que contemplou a implementação de cinco soluções educacionais para ajudar a rede de ensino a lidar com
                            os desafios de alfabetização, atraso escolar, defasagem de aprendizagens e gestão escolar.
                        </p>
                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Quadro informativo apresentando o dado: mais de 39 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +39 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </StyledGlobal.TableWrapper>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={35} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title style={{ color: Colors.Blue, fontSize: '24px' }}>3.3.3 RESULTADOS</StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            A parceria de Maceió com o Instituto Ayrton Senna tem apoiado na promoção de uma educação de qualidade para todas as
                            crianças e os primeiros resultados já são visíveis, com estudantes demonstrando melhorias perceptíveis no
                            aprendizado.
                        </p>
                        <p>
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                16 cursos presenciais com técnicos(as) da secretaria de educação, diretores(as), coordenadores(as)
                                pedagógicos(as) e professores(as),
                            </strong>{' '}
                            a fim de preparálos(as) para implementar os diferentes programas educacionais no município: Gestão Nota 10, Fórmula
                            da Vitória, Circuito 360, Se Liga e Acelera Brasil. Além disso, foram <strong>realizados 23 cursos virtuais,</strong>{' '}
                            para que os(as) educadores(as) tivessem acesso contínuo às formações.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Os(as) participantes avaliaram as formações de forma muito positiva, <br />
                            <strong style={{ fontSize: '24px' }}> alcançando um nível de satisfação médio de 90%.</strong>
                        </p>
                        <p>
                            Além das formações sobre os programas educacionais, os(as) profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <StyledGlobal.CardGray
                            style={{ maxWidth: '250px' }}
                            role="img"
                            aria-label="Foram realizadas 9 oficinas presenciais e 11 oficinas virtuais"
                        >
                            <span> Foram realizadas</span> <strong>9 oficinas presenciais e 11 oficinas virtuais</strong>
                        </StyledGlobal.CardGray>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Quote
                            text={`
                            A maneira como
                            foi conduzido cada
                            encontro, com clareza,
                            comprometimento
                            e dinamismo. Cada
                            troca de experiência, a
                            escuta, a nossa turma
                            participativa e integrada,
                            apresentando soluções
                            a partir dos temas
                            abordados.”
                            <br/>
                            <br/>
                           
                            Depoimento de um(a)
                            participante dos cursos
                            presenciais

                            `}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            width={'100%'}
                            src={fetchStorageFile('anexo_storage_files_92999272089541104.webp_2025-11-20-1763650690930.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={36} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr ',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Maceió fortaleceu o acompanhamento de resultados com a{' '}
                                    <strong>institucionalização de um Comitê Gestor,</strong> que estrutura a governança e integra o uso de dados
                                    ao dia a dia, engajando todos os atores na responsabilização e na busca de soluções. O colegiado inclui o
                                    Secretário de Educação, equipes da Secretaria e especialistas do Instituto Ayrton Senna.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Cada programa definiu o que medir e quem acompanha, e uma{' '}
                                    <strong>plataforma passou a reunir os dados,</strong> apoiando decisões ágeis focadas no desenvolvimento
                                    integral dos estudantes.
                                </p>
                                <p>
                                    O perfil dos(as) estudantes atendidos(as) variou de acordo com o programa implementado, como mostram os
                                    gráficos ao lado.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <StyledGlobal.Content style={{ alignItems: 'end' }}>
                            <Image
                                width={'70%'}
                                style={{
                                    maxHeight: '380px',
                                    objectFit: 'cover',
                                }}
                                src={fetchStorageFile('anexo_storage_files_798103827186855374.webp_2025-11-20-1763651679193.webp')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.Content>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px' }}>
                            <h2 style={{ fontSize: '14px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <Image
                                    width={'100%'}
                                    src={fetchStorageFile('anexo_storage_files_18124798002893123981.png_2025-11-20-1763651275679.png')}
                                    alt={`
                                        Gráfico de pizza mostrando a distribuição por idade dos estudantes do Acelera Brasil: 10 anos (23,8%), 11 anos (39,6%), 12 anos (30,7%), 13 anos (5%) e 14 anos (1%). 
                                        Cada fatia identifica a porcentagem por faixa etária. 
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                                <Image
                                    width={'100%'}
                                    src={fetchStorageFile('anexo_storage_files_5617773196312695273.png_2025-11-20-1763651304487.png')}
                                    alt={`
                                        Gráfico de pizza representando distribuição de idades no programa Se Liga: 10 anos (31,6%), 11 anos (31,6%), 12 anos (21,2%), 13 anos (11,3%), 
                                        14 anos (3%) e 15 anos ou mais (1,2%). Cada fatia identifica a porcentagem por faixa etária. 
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </ResponsiveGrid>
                            <p>
                                As turmas do Acelera Brasil foram compostas por estudantes entre 10 a 14 anos, sendo 24% com 10 anos (equivalente
                                ao 5º do Ensino Fundamental), 40% 11 anos, 31% 12 anos e 6% acima dessa idade.{' '}
                            </p>
                            <br />
                            <br />
                            <p>
                                As turmas do Se Liga apresentaram uma distribuição etária parecida, com 63% dos(as) estudantes com idades entre
                                10 e 11 anos.
                            </p>
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={37} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Os programas já começaram a apresentar alguns efeitos no sentido da melhoria no aprendizado dos(as)
                                    estudantes. Nas turmas do Acelera Brasil,{' '}
                                    <strong>nenhum(a) aluno(a) conseguia escrever palavras com sílabas complexas</strong> no início da
                                    implementação, em maio.{' '}
                                    <strong>Em setembro, essa competência já podia ser observada em metade dos(as) alunos(as).</strong> Em
                                    relação à produção textual, no início do ano, 64% dos(as) estudantes estavam no nível mais baixo da escala de
                                    proficiência, caracterizada pela escrita de frases soltas dentro do tema. Em setembro, este percentual caiu
                                    mais da metade.
                                    <br />
                                    <br />
                                    No Se Liga os resultados também são expressivos. Em maio, 85% dos estudantes estavam no nível mais baixo de
                                    proficiência em Língua Portuguesa, equivalente ao Ensino Infantil. Em setembro, o percentual havia caído
                                    quase pela metade (46%).
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Styled.CardWhite2 style={{ padding: '20px' }}>
                                    <h2 style={{ fontSize: '14px' }}>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                                    <Image
                                        style={{ maxHeight: '400px' }}
                                        src={fetchStorageFile('anexo_storage_files_5273382717353462966.png_2025-11-20-1763659082098.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em azul representando o percentual de estudantes do Acelera Brasil que escrevem palavras com sílabas complexas.  
                                            Texto que acompanha o primeiro grupo diz: ‘Em maio, nenhum estudante conseguia escrever palavras com sílabas complexas’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, essa competência podia ser observada em metade dos estudantes’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                    <Image
                                        style={{ maxHeight: '400px' }}
                                        src={fetchStorageFile('anexo_storage_files_5138541443711564738.png_2025-11-20-1763659120821.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes do Se Liga no nível mais baixo em língua portuguesa. 
                                            Texto que acompanha o primeiro grupo diz: ‘Em maio, 85% estavam no nível mais baixo de Língua Portuguesa’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, o percentual havia caído para 46%, ou seja, quase pela metade’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </Styled.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Um outro <strong>resultado muito significativo é a rotina de leitura dos(as) alunos(as).</strong> No início
                                    do programa, as médias de livros lidos pelos(as) estudantes das turmas do Acelera e do Se Liga eram de apenas{' '}
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    0,2 e 0,3, respectivamente. Em setembro, houve um avanço nos dois programas, os(as) estudantes do Acelera
                                    Brasil leram 2,2 livros, enquanto os estudantes do Se Liga leram 1,6 livros.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Styled.CardWhite2 style={{ padding: '20px' }}>
                            <Image
                                width={'80%'}
                                src={fetchStorageFile('anexo_storage_files_13190653383707367355.png_2025-11-20-1763659300037.png')}
                                alt={`
                                    Conjunto de ícones de livros para comparar a média de livros lidos por estudante antes e depois da participação nos programas. 
                                    No Acelera Brasil: o número de livros lidos aumentou de 0,2 para 2,2 livros por estudante, representado por ícones de livros e seta indicando crescimento de ‘11 vezes mais’. 
                                    No Se Liga: o número de livros lidos aumentou de 0,3 para 1,6 livros por estudante, com seta indicando ‘5 vezes mais’.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={38} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Este resultado foi potencializado pela <strong>distribuição de livros para os(as) estudantes.</strong> Em 2025, foram
                            mais de 9 mil livros distribuídos, sendo{' '}
                            <strong>4.894 livros pedagógicos e 4.250 livros de literatura infanto-juvenil,</strong> incluindo exemplares com
                            conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                        </p>
                        <Styled.CardWhite2 style={{}}>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_16342602604277585402.png_2025-11-20-1763659641610.png')}
                                alt={`
                                    Quadro com quatro ícones de livros indicando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. 
                                    Acelera Brasil: 1.131 livros; Se Liga: 552 livros; Fórmula da Vitória: 3.211 livros; Livros de Literatura: 4.250 livros 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px', gap: '40px' }}>
                            <h2 style={{ fontSize: '18px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_867235845368757489.png_2025-11-20-1763659711006.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={39} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além dos efeitos sobre a alfabetização e aumento da proficiência, a prática da leitura, potencializada pelo acesso à
                            um acervo diversificado amplia{' '}
                            <strong>o repertório cultural, contribuindo ainda mais para o desenvolvimento integral dessas crianças.</strong>
                        </p>
                        <p>
                            No âmbito do programa <strong>Fórmula da Vitória,</strong> estudantes em processo de recomposição das aprendizagens
                            em Língua Portuguesa encontraram na poesia uma forma de expressão e reconexão com o aprender. O resultado desse
                            movimento é um livro que reúne poemas criados nas escolas e que será compartilhado com as escolas da rede municipal
                            de ensino. Serão
                            <strong>impressos 2 mil exemplares,</strong> simbolizando o alcance e a força dessa produção coletiva. A iniciativa
                            valoriza o protagonismo dos(as) estudantes e reforça a escola como lugar de cultura, sensibilidade e desenvolvimento
                            integral.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            src={fetchStorageFile('anexo_storage_files_6894724456882107858.webp_2025-11-20-1763660449204.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                        <Styled.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_3870002160293739663.png_2025-11-20-1763660499443.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Integrando as ações do programa <strong>Acelera Brasil,</strong> os(as) estudantes mergulharam em experiências que os
                            aproximaram do patrimônio cultural de sua cidade. A partir desse movimento nasceu um <strong>curtametragem</strong>{' '}
                            que sintetiza o aprendizado e as descobertas realizadas ao longo do percurso. O projeto possibilitou que os(as)
                            alunos(as) reconhecessem a riqueza de suas origens, fortalecendo vínculos com a comunidade e despertando o desejo de
                            preservar e valorizar sua cultura local.
                        </p>
                        <p>
                            As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas com nota máxima pela equipe central na
                            Secretaria de Educação, com <strong>100% de satisfação</strong> em todos os aspectos avaliados.
                        </p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={40} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>

                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '380px 200px',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <Image
                                src={fetchStorageFile('anexo_storage_files_14964818823171344073.webp_2025-11-20-1763661176760.webp')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p>
                                Alice precisou se afastar da escola para cuidar de sua avó. Por conta disso, atrasou seu desempenho escolar e
                                prejudicou sua alfabetização. Aos 12 anos, sentia vergonha por não conseguir fazer as mesmas coisas que crianças
                                de sua idade. Alguns meses após ingressar em uma turma do Acelera Brasil, Alice já se sente uma nova pessoa.{' '}
                            </p>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Quote
                            text={`
                            Eu tenho muitos
                            amigos na minha
                            sala, todo mundo fala
                            comigo, não sou mais
                            excluída. Quando eu
                            peguei um livro pra ler,
                            já tinha um mês que
                            eu estava no Acelera
                            Brasil, eu tava assim
                            lendo muito rápido!”
                            `}
                        />
                        <CardQRcodeVideosPlanoAnual />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            src={fetchStorageFile('anexo_storage_files_11809794232876567241.webp_2025-11-20-1763661135217.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeThreePlanoAnual;
